export default __webpack_public_path__ + "static/media/257.94411c69.png";